



















































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import ReportControls, { ReportSpecByWeek } from '../components/ReportControls.vue';
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiAutorenew } from '@mdi/js';
import axios from 'axios';

export default Vue.extend({
  name: 'TieredCustomers',
  components: {
    ReportControls,
    SvgIcon,
  },
  data() {
    return {
      path: mdiAutorenew,
      size: 48,
      spec: {} as ReportSpecByWeek,
      loading: true,
      customerData: [],
      prevMthCustomerData: {} as any,
      billingUnitData: [],
      selectedMonth: '',
      monthDays: 0,
      goldMonthTotal: 0,
      goldDayTotal: 0,
      silverMonthTotal: 0,
      silverDayTotal: 0,
      balanceMonthTotal: 0,
      balanceDayTotal: 0,
      currentWeekGoldTotals: [],
      previousWeekGoldTotals: 0,
      currentWeekSilverTotals: 0,
      previousWeekSilverTotals: 0,
      currentWeekBalanceTotals: [],
      previousWeekBalanceTotals: [],
      overallBuTotals: [],
      dayAveMod: 5,
      isCurrentWeek: true,
      // Key is "{customer}::{level}::{week}", with rollups indicated by underscores
      // e.g. total for week 9 silver is "_::silver::9"
      monthlies: {} as { days: number, weeks: number[], data: { [key: string]: number } },
    };
  },
  computed: {
    dataUrl(): string {
      const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';
      const { depot, from, to } = this.spec;
      return `${BASE_URL}/reports/tiered-customers/${depot}/${from.year}/${from.week}/${to.year}/${to.week}/`;
    },
    monthliesDataUrl(): string {
      const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';
      const { depot, from, to } = this.spec;
      return `${BASE_URL}/reports/tiered-customers/month/${depot}/${from.year}/${from.week}/`;
    },
    overallMonthTotal(): number {
      return this.goldMonthTotal + this.silverMonthTotal + this.balanceMonthTotal;
    },
    overallDayTotal(): number {
      return this.goldDayTotal + this.silverDayTotal + this.balanceDayTotal;
    },
    prevMthODT(): number {
      return this.prevMthCustomerData.prevMthGoldDayTotal +
          this.prevMthCustomerData.prevMthSilverDayTotal + this.prevMthCustomerData.prevMthBalanceDayTotal;
    },
    currentWeek(): number {
      return this.spec.from.week;
    },
    previousWeek(): number {
      if (this.currentWeek === 1) {
        return 1;
      } else {
        return this.spec.from.week - 1;
      }
    },
  },
  watch: {
    spec: {
      immediate: true,
      async handler() {
        if (!this.spec.from) {
          return;
        }
        this.loading = true;
        const response = await axios.get(this.dataUrl, {
          params: {
            account_codes: this.spec.accountCodes.flatMap((a) => a.codes),
          },
        });
        this.customerData = response.data.customerData;
        this.prevMthCustomerData = response.data.prevMthCustomerData;
        this.selectedMonth = response.data.month;
        this.monthDays = response.data.days;
        this.goldMonthTotal = response.data.goldMonthTotal;
        this.goldDayTotal = response.data.goldDayTotal;
        this.silverMonthTotal = response.data.silverMonthTotal;
        this.silverDayTotal = response.data.silverDayTotal;
        this.balanceMonthTotal = response.data.balanceMonthTotal;
        this.balanceDayTotal = response.data.balanceDayTotal;
        this.currentWeekGoldTotals = response.data.currentWeekGoldTotals;
        this.previousWeekGoldTotals = response.data.previousWeekGoldTotals;
        this.currentWeekSilverTotals = response.data.currentWeekSilverTotals;
        this.previousWeekSilverTotals = response.data.previousWeekSilverTotals;
        this.currentWeekBalanceTotals = response.data.currentWeekBalanceTotals;
        this.previousWeekBalanceTotals = response.data.previousWeekBalanceTotals;
        this.overallBuTotals = response.data.totalBuData;
        this.isCurrentWeek = response.data.isCurrentWeek;

        const monthliesResponse = await axios.get(this.monthliesDataUrl, {
          params: {
            account_codes: this.spec.accountCodes.flatMap((a) => a.codes),
          },
        });
        this.monthlies = monthliesResponse.data;
        this.loading = false;
      },
    },
  },
  methods: {
    calcPercentDiff(budget: number, actual: number): number {
      return Math.round((actual / budget) * 100);
    },
    calcDayCount(): number {
      if (this.isCurrentWeek) {
        const currentDayNum = new Date().getDay();
        if (currentDayNum === 1) {
          // Monday - nothing much to show yet
          return 1;
        }
        if (currentDayNum > 1 && currentDayNum < 6) {
          return currentDayNum - 1;
        }
      }
      return this.dayAveMod;
    },
    calcWeeklyTotal(level: string, week: number): number {
      return Object.entries(this.monthlies.data).reduce(
          (acc, [k, v]) =>
              k.endsWith(`::${level}::${week}`) || (level === "_" && k.endsWith(`::${week}`))
                  ? acc + v
                  : acc,
          0)
    }
  },
});

